import React, { useMemo } from "react";
import { useTable, usePagination, SortingRule, useSortBy } from "react-table";
import PaginationV2 from "../../../Common/PaginationV2";
import TableStyle from "./Table.module.css";

interface Prop {
  columns: any[];
  data: any[];
  linePerPage: number;
  sortBy?: SortingRule<any>[];
}

export default function Table({ columns, data, linePerPage, sortBy }: Prop) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    prepareRow,
    canNextPage,
    canPreviousPage,
    nextPage,
    previousPage,
    pageCount,
    gotoPage,
    state: { pageIndex, pageSize, filters },
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: linePerPage,
        pageIndex: 0,
        sortBy: sortBy,
      },
    },
    useSortBy,
    usePagination
  );

  return (
    <div>
      <div>
        <table
          {...getTableProps()}
          style={{
            border: "1px solid #B4B4B4",
            borderRadius: "4px",
            borderCollapse: "collapse",
          }}
        >
          <thead className={TableStyle["table-header"]}>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={(cell.column as any).getProps(
                          cell,
                          data[Number(cell.row.id)]
                        )}
                        className={TableStyle["table-cell-data"]}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <PaginationV2
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        pageCount={pageCount}
        gotoPage={gotoPage}
        nextPage={nextPage}
        previousPage={previousPage}
        pageIndex={pageIndex}
        elementPerPage={linePerPage}
        totalElement={data.length}
      />
    </div>
  );
}
